import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Routes } from '@/_shared';
import { getModeTheme } from '@/_shared/styles/state/selectors';
import { LoginCta, Login } from '../components';
import { useLogin } from '../state';

export const LoginScreen = () => {
  const t = useTranslations('login');
  const mode = useSelector(getModeTheme());
  const navigate = useNavigate();
  const { isUserLogged } = useLogin();

  const title = t('title');
  const subTitle = t('subTitle');

  const slides = [
    {
      title: t('slides.slide1.title'),
      subtitle: t('slides.slide1.subtitle'),
      assetName: 'slide1',
    },
    {
      title: t('slides.slide1.title'),
      subtitle: t('slides.slide1.subtitle'),
      assetName: 'slide1',
    },
  ];

  useEffect(() => {
    if (isUserLogged) {
      navigate(Routes.Homepage);
    }
  }, [isUserLogged, navigate]);

  return (
    <Login
      titleLoginForm={title}
      subTitleLoginForm={subTitle}
      logoLoginForm={mode === 'light' ? 'logoLight' : 'logoDark'}
      logoWidth={200}
      slides={slides}
      childrenLogin={<LoginCta />}
    />
  );
};
